import { Component, ComponentRef, effect, inject, Injector, inputBinding, outputBinding, signal, Type, viewChild, ViewChild, ViewContainerRef, ChangeDetectionStrategy } from '@angular/core';
import { SessionStatus } from '@/core/model/session-status';
import { SessionMonitorService } from '@/core/service/session-monitor.service';
import { SessionDurationLocked } from '@/core/template/session-duration-locked';
import { SessionDurationExpired } from '@/core/template/session-duration-expired';
import { SessionDuplicate } from '@/core/template/session-duplicate';
import { STORAGE_SERVICE_TOKEN } from '@/core/util/storage.token';
import { STORAGE_KEYS } from '@/share/constant/storage_token.key';

@Component({
    selector: 'app-dynamic-session-handler',
    template: ` <ng-container #dynamicContainer></ng-container>`,
    changeDetection: ChangeDetectionStrategy.Eager
})
export class DynamicSessionHandler {
    @ViewChild('dynamicContainer', { read: ViewContainerRef }) dynamicContainer!: ViewContainerRef;
    readonly vcr = viewChild.required('dynamicContainer', { read: ViewContainerRef });
    componentRef?: ComponentRef<any>;
    private storageService = inject(STORAGE_SERVICE_TOKEN);

    constructor(
        private injector: Injector,
        private sessionMonitor: SessionMonitorService
    ) {
        effect(() => {
            switch (this.sessionMonitor.sessionStatus()) {
                case SessionStatus.ReloginPrompt:
                    this.load(SessionDurationLocked);
                    this.storageService.set(STORAGE_KEYS.SESSION_MONITOR, SessionStatus.ReloginPrompt);
                    break;
                case SessionStatus.LogoutPrompt:
                    this.load(SessionDurationExpired);
                    this.storageService.set(STORAGE_KEYS.SESSION_MONITOR, SessionStatus.LogoutPrompt);
                    break;
                case SessionStatus.DuplicateSession:
                    this.storageService.set(STORAGE_KEYS.SESSION_MONITOR, SessionStatus.DuplicateSession);
                    this.load(SessionDuplicate);
                    break;
                default:
                    break;
            }
        });
    }

    loadComponent(componentType: Type<any>) {
        this.dynamicContainer.clear();
        const componentRef = this.dynamicContainer.createComponent(componentType, { injector: this.injector });
        componentRef.instance.visible = true;
        componentRef.instance.onHide.subscribe(() => this.clear());
    }

    clear() {
        this.dynamicContainer.clear();
    }

    load(component: Type<any>): void {
        this.vcr()?.clear();
        this.componentRef = this.vcr().createComponent(component, {
            bindings: [
                outputBinding('onHide', () => {
                    this.componentRef?.destroy();
                    // this.sessionMonitor.setStatus(SessionStatus.Active);
                    // this.sessionMonitor.initTimer();
                })
            ]
        });
    }
}
